import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Printer, ArrowLeft } from 'lucide-react'
import { getCertificateByEnrollment, type CertificateResult } from '@/services/certificateService'
import CertificateCard from './CertificateCard'

export default function CertificateView() {
  const { enrollmentId } = useParams<{ enrollmentId: string }>()
  const [certificate, setCertificate] = useState<CertificateResult | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!enrollmentId) return
    getCertificateByEnrollment(enrollmentId)
      .then(setCertificate)
      .catch((err) => setError(err instanceof Error ? err.message : 'ไม่พบใบประกาศ'))
      .finally(() => setLoading(false))
  }, [enrollmentId])

  return (
    <div className="min-h-screen bg-[#FAFAFB] pt-24 pb-16">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-6 flex items-center justify-between print:hidden">
          <Link to="/account?tab=certificates" className="flex items-center gap-1.5 text-sm text-text-muted hover:text-accent">
            <ArrowLeft className="h-4 w-4" />
            กลับไปรายการใบประกาศ
          </Link>
          {certificate && (
            <button
              onClick={() => window.print()}
              className="flex items-center gap-2 rounded-xl bg-gradient-to-r from-accent to-accent2 px-4 py-2.5 text-sm font-semibold text-white shadow-lg shadow-accent/25 hover:shadow-accent/40 transition-all"
            >
              <Printer className="h-4 w-4" />
              ดาวน์โหลด PDF
            </button>
          )}
        </div>

        {loading ? (
          <p className="text-sm text-text-muted">กำลังโหลด...</p>
        ) : error ? (
          <p className="text-sm text-rose-500">{error}</p>
        ) : certificate ? (
          <>
            <CertificateCard certificate={certificate} />
            <p className="mt-4 text-center text-xs text-text-muted print:hidden">
              เลขที่ใบประกาศ: {certificate.certificate_number}
            </p>
          </>
        ) : null}
      </div>
    </div>
  )
}
